import { createSlice } from '@reduxjs/toolkit';

const initialState = { showList: false };

const listPrevSignersSlice = createSlice({
  name: 'listPrevSigners',
  initialState,
  reducers: {
    toggleShowList: (state, action) => {
      state.showList = !state.showList;
    }
  }
});

export const { toggleShowList } = listPrevSignersSlice.actions;
export default listPrevSignersSlice.reducer;
